import {EditService} from "../../../../framework/entity/edit/edit-page/edit.service";
import {AccountTypeEntityModel} from "../../account-type-entity.model";
import {Component} from "@angular/core";

@Component({
    selector: "wbo-account-type-edit-invoicing-statements",
    templateUrl: "./account-type-edit-invoicing-statements.component.html"
})
export class AccountTypeEditInvoicingStatementsComponent {
    constructor(public model: AccountTypeEntityModel, public editService: EditService) {
    }
}
